import "./HowVPNsReduceLag.module.css";
import Header from "@/reusable_sections/Header";
import Lagreductionhero from "./sections/Lagreductionhero";
import Gaming from "./sections/Gaming";
import Gamingnetworkoptimization from "./sections/Gamingnetworkoptimization";
import Relatedgamingarticles from "./sections/Relatedgamingarticles";
import Affiliate from "./sections/Affiliate";
import Performance from "./sections/Performance";
import Footer from "@/reusable_sections/Footer";
export default function HowVPNsReduceLagPage() {
  return <div>
      <Header />
      <Lagreductionhero />
      <Gaming />
      <Gamingnetworkoptimization />
      <Relatedgamingarticles />
      <Performance />
      <Affiliate />
      <Footer />
    </div>;
}